// extracted by mini-css-extract-plugin
module.exports = {"PreviewErrorFrame":"PreviewErrorFrame_PreviewErrorFrame__bMg/0"};